<ng-template #subscriptionsInfoModal>
  <div class="modal__title h2">{{ 'rules-block.title' | translate }}</div>
  <div class="modal__rules-subtitle">{{ 'rules-block.subtitle' | translate }}</div>
  <div class="modal__content">
    <div class="track-rule" *ngFor="let rule of newRules" [class.track-rule__opened]="rule.shown">
      <div class="track-rule__trigger">
        <div class="track-rule__song" app-subscriber-melody-item [melody]="rule.melody">
        </div>
        <div class="track-rule__controls">
          <div class="track-rule__control">
            <label class="checkbox">
              <input type="checkbox" class="checkbox__input"
                     [(ngModel)]="rule.enabled"
                     [disabled]="isAnyPromoRuleBlocked()"
                     (ngModelChange)="updateRulesActivity(rule)"/>
              <div class="checkbox__style-container">
                <div class="checkbox__style"></div>
              </div>
            </label>
          </div>
          <div class="track-rule__control track-rule__opener" *ngIf="rule.melody.idFromPlatform > 0" (click)="rule.shown = !rule.shown">
            <div class="icon icon-chevron"></div>
          </div>
        </div>
      </div>
      <div class="track-rule__content" *ngIf="rule.melody.idFromPlatform > 0" [style.display]="rule.shown ? 'block' : 'none'">
        <div class="track-rule__field">
          <div class="week">
            <div class="week__label">{{ 'rules-block.days-rule' | translate }}</div>
            <div class="week__days" [class.week__days_disabled]="rule.startTime?.length > 0 || rule.endTime?.length > 0">
              <div class="week__item" [class.week__item-active]="rule.monday" (click)="toggleMonday(rule)">{{ 'rules-block.mon' | translate }}</div>
              <div class="week__item" [class.week__item-active]="rule.tuesday" (click)="toggleTuesday(rule)">{{ 'rules-block.tue' | translate }}</div>
              <div class="week__item" [class.week__item-active]="rule.wednesday" (click)="toggleWednesday(rule)">{{ 'rules-block.wed' | translate }}</div>
              <div class="week__item" [class.week__item-active]="rule.thursday" (click)="toggleThursday(rule)">{{ 'rules-block.thu' | translate }}</div>
              <div class="week__item" [class.week__item-active]="rule.friday" (click)="toggleFriday(rule)">{{ 'rules-block.fri' | translate }}</div>
              <div class="week__item" [class.week__item-active]="rule.saturday" (click)="toggleSaturday(rule)">{{ 'rules-block.sat' | translate }}</div>
              <div class="week__item" [class.week__item-active]="rule.sunday" (click)="toggleSunday(rule)">{{ 'rules-block.sun' | translate }}</div>
            </div>
          </div>
        </div>
        <div class="track-rule__field">
          <div class="time-range">
            <div class="time-range__label">{{ 'rules-block.time-rule' | translate }}</div>
            <div class="time-range__field">
              <div class="time-range__input">
                <div class="input input_width_auto"
                     [class.input_type_disabled]="rule.monday || rule.tuesday || rule.wednesday || rule.thursday || rule.friday || rule.saturday || rule.sunday">
                  <div class="input__container">
                    <input type="text" placeholder="10:00" class="input__input" [(ngModel)]="rule.startTime" mask="Hh" suffix=":00" [leadZeroDateTime]="true"
                           (ngModelChange)="timeChanged(rule)"/>
                  </div>
                </div>
              </div>
              <div class="time-range__separator icon-subtract"></div>
              <div class="time-range__input">
                <div class="input input_width_auto"
                     [class.input_type_disabled]="rule.monday || rule.tuesday || rule.wednesday || rule.thursday || rule.friday || rule.saturday || rule.sunday">
                  <div class="input__container">
                    <input type="text" placeholder="18:00" class="input__input" [(ngModel)]="rule.endTime" mask="Hh" suffix=":00" [leadZeroDateTime]="true"
                           (ngModelChange)="timeChanged(rule)"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal__buttons-row modal__buttons-mt72">
    <div class="button" [class.button_type_load]="requestInProgress" (click)="save()">{{ 'rules-block.save' | translate }}</div>
  </div>
</ng-template>
<ng-container *ngIf="showInfoModal; else subscriptionsInfoModal">
  <div class="modal__container">
    <div class="modal__title modal__title-mb24 h2">{{ 'subscriptions-modal-info.subscription-title' | translate }}</div>
    <div class="modal__content">
      <div class="modal__plan">
        <div class="modal-plan__text" *ngIf="!privetProSubscriptionStatus">{{ 'subscriptions-modal-info.subscription-privet-text' | translate }}</div>
        <div class="modal-plan__text" *ngIf="privetProSubscriptionStatus">{{ 'subscriptions-modal-info.subscription-privet-pro-text' | translate }}</div>
      </div>
    </div>
  </div>
  <div class="modal__buttons-row modal__buttons-mt40">
    <div class="button" (click)="showInfoModal = false; close()">{{ 'subscriptions-modal-info.button' | translate }}</div>
  </div>
</ng-container>
